// @moods/ui copy for the voice components. tr and en must have identical keys.
// Turkish is the design-system source copy (sentence case; "CANLI" and "KAYIT" are the all-caps badges).
// Turkish part; voice.en.ts must have the same keys.
const dict: Record<string, string> = {
  'voice.live': 'CANLI',
  // v1.1 recordings: the badge on a recorded voice / stage channel (sidebar, voice module)
  'voice.recording': 'KAYIT',
  'voice.recordingLabel': 'Bu kanal kaydediliyor',
  'voice.speaking': 'konuşuyor',
  'voice.micOff': 'Mikrofon kapalı',
  'voice.deafened': 'Sağırlaştırılmış',
  'voice.viewers': '{count} izleyici',

  'voice.tile.focus': 'Odakla',
  'voice.tile.more': 'Daha fazla',

  'voice.dock.label': 'Arama kontrolleri',
  'voice.dock.mute': 'Mikrofonu kapat',
  'voice.dock.micDevice': 'Mikrofon cihazı',
  'voice.dock.camera': 'Kamera',
  'voice.dock.cameraDevice': 'Kamera cihazı',
  'voice.dock.share': 'Ekran paylaş',
  'voice.dock.deafen': 'Sağırlaştır',
  'voice.dock.more': 'Daha fazla',
  'voice.dock.leave': 'Ayrıl',
  'voice.dock.device': '{label} cihazı',

  'voice.room.people': '{count} kişi',
  'voice.room.join': 'Katıl',

  'voice.pip.label': 'Mini yayın',
  'voice.pip.mute': 'Yayını sessize al',
  'voice.pip.return': 'Geri dön',
  'voice.pip.returnHint': 'Görüşmeye dönmek için tıkla',
  'voice.pip.close': 'Kapat',
  'voice.pip.moveHint': 'Başka bir köşeye taşımak için ok tuşlarını kullan',
  'voice.pip.resize': 'Boyutlandır',

  'voice.level.label': 'Giriş seviyesi',
  'voice.level.value': '{db} dB',

  'voice.conn.label': 'Ses bağlantısı',
  'voice.conn.connected': 'Ses bağlı',
  'voice.conn.weak': 'Bağlantı zayıf',
  'voice.conn.connecting': 'RTC bağlanıyor…',
  'voice.conn.reconnecting': 'Yeniden bağlanıyor…',
  'voice.conn.failed': 'Bağlantı başarısız',
  'voice.conn.ping': '{ms} ms',
  'voice.conn.openRoom': 'Ses odasına dön: {room}',
  'voice.conn.openView': 'Görüşmeyi aç',
  'voice.conn.noise': 'Gürültü engelleme',
  'voice.conn.camera': 'Kamera',
  'voice.conn.share': 'Ekran paylaş',
  'voice.conn.activity': 'Etkinlik',
  'voice.conn.disconnect': 'Bağlantıyı kes',
  'voice.conn.retry': 'Yeniden bağlan',

  'voice.quality.good': 'Bağlantı: iyi',
  'voice.quality.fair': 'Bağlantı: orta',
  'voice.quality.poor': 'Bağlantı: zayıf',

  'voice.stage.sharing': '{name} ekranını paylaşıyor',
  'voice.stage.quality': 'Kalite',
  'voice.stage.fps': 'Kare hızı',
  'voice.stage.volume': 'Yayın sesi',
  'voice.stage.popout': 'Ayrı pencerede aç',
  'voice.stage.fullscreen': 'Tam ekran',
};

export default dict;
